import React, { useEffect, useState } from 'react';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Popover from 'components/molecules/Popover';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';

import FilterListIndex from './FilterListIndex';

let closePopover = () => {};
const DisplayFilter = ({
  id,
  handleOnClickFilter,
  advrtsPrdtCode,
  displayFilterList,
  params,
  advrtsTpCodeJson,
  required = [],
}) => {
  const { t } = useTranslation();
  const { allProductCodeList, productCodeList } = useSelector(({ common }) => ({
    allProductCodeList: common.allProductCodeList,
    productCodeList: common.productCodeList,
  }));
  const [selectedTpCodes, setSelectedTpCodes] = useState(false);
  const [selectedPrdtCode, setSelectedPrdtCode] = useState(null);
  const [filterList, setFilterList] = useState({
    allProductCode: productCodeList,
    productCode: productCodeList,
  });

  useEffect(() => {
    let newList = { ...filterList };
    if (newList.allProductCode !== allProductCodeList) {
      newList = {
        ...newList,
        allProductCode: allProductCodeList,
      };
    }
    if (newList.productCode !== productCodeList) {
      newList = {
        ...newList,
        productCode: productCodeList,
      };
    }
    setFilterList({ ...newList });
    // eslint-disable-next-line
  }, [allProductCodeList, productCodeList]);

  useEffect(() => {}, [selectedTpCodes]);
  useEffect(() => {
    if (typeof params.advrtsTpCode === 'undefined') {
      setSelectedTpCodes(false);
      setSelectedPrdtCode(null);
    } else {
      let newAdvrtsTpCode = params.advrtsTpCode;
      let ObjTpCode = newAdvrtsTpCode.split(',');
      let result = {};
      for (let i = 0; ObjTpCode.length > i; i++) {
        const tempValue = ObjTpCode[i];
        result[tempValue] = 1;
      }
      setSelectedTpCodes(result);
      setSelectedPrdtCode(params.advrtsPrdtCode);
    }
  }, [params]);

  const [alert, setAlert] = useState({
    message: '',
    state: false,
  });

  /**
   * 선택된 디스플레이 필터 리스트 반환
   * @param {array} tpCodeArray 선택한 tpCode 배열
   * @param {Map} allProductCodeList
   */
  const returnSelectedLabel = (codeList) => {
    let tpCodeArray = '';
    let resultStr = '';
    if (typeof params.advrtsTpCode !== 'undefined') {
      tpCodeArray = params.advrtsTpCode.split(',');

      const MAX = 5;
      const codeNameArray = [];

      for (let i = 0; i < tpCodeArray.length; i++) {
        const selectedCode = tpCodeArray[i];
        codeNameArray.push(codeList.get(selectedCode).label);
      }
      if (codeNameArray.length <= MAX) {
        resultStr = codeNameArray.join(', ');
      } else {
        resultStr = i18next.t('외', {
          list: codeNameArray.slice(0, MAX).join(', '),
          count: codeNameArray.length - MAX,
        });
      }
    }
    return resultStr;
  };
  /**
   * 스넥바 닫는 함수
   */
  const handleAlertClose = () => {
    setAlert({
      state: false,
      message: '',
    });
  };

  /**
   * 디스플레이 검색
   */
  const handleSaveClick = (e) => {
    let tpCodes = Object.keys(selectedTpCodes).join(',');
    let checkFalg = true;
    let tempAlert = alert;

    if (required !== null) {
      required.map((requiredVal) => {
        if (requiredVal === 'advrtsPrdtCode') {
          if (selectedPrdtCode === '') {
            tempAlert = {
              ...tempAlert,
              state: true,
              message: t('상품유형 선택은 필수입니다.'),
            };
            checkFalg = false;
            setAlert({ ...tempAlert });
          }
        }
        if (requiredVal === 'advrtsTpCode') {
          if (tpCodes === '') {
            tempAlert = {
              ...tempAlert,
              state: true,
              message: t('타게팅 선택은 필수입니다.'),
            };
            checkFalg = false;
            setAlert({ ...tempAlert });
          }
        }
        return false;
      });
    }

    if (selectedTpCodes !== false && checkFalg) {
      let newParams = {};
      if (tpCodes !== '') {
        newParams = {
          ...params,
          advrtsTpCode: tpCodes,
          advrtsPrdtCode: selectedPrdtCode,
        };
      } else {
        newParams = {
          ...params,
          advrtsTpCode: '00',
          advrtsPrdtCode: '00',
        };
      }
      handleOnClickFilter({
        params: newParams,
      });
      closePopover();
    }
  };

  /**
   * 필터창 닫는 핸들링 받아오는 함수
   */
  const getOnClose = (handleClose) => {
    closePopover = handleClose;
  };

  /**
   * 디스플레이 필터 선택 관련
   */
  const handleOnClick = (advrtsPrdtCode, advrtsTpCode, checked) => {
    let newAdvrtsTpCodeJson = {
      ...advrtsTpCodeJson,
    };
    let selectedCodes = {
      ...selectedTpCodes,
    };

    if (selectedPrdtCode !== advrtsPrdtCode) {
      if (!(selectedPrdtCode === null && advrtsPrdtCode === null)) {
        newAdvrtsTpCodeJson = {};
        selectedCodes = {};
      }
      if (advrtsPrdtCode === null) {
        // 타게팅별 필터링
        setSelectedPrdtCode(null);
      } else {
        // 상품별 필터링
        // 다른 상품 선택한 경우
        setSelectedPrdtCode(advrtsPrdtCode);
      }
    }

    if (advrtsTpCode === 'Y' || advrtsTpCode === 'N') {
      //타겟팅 리스트
      if (checked) {
        for (let prdtItem of productCodeList.values()) {
          if (advrtsPrdtCode === null) {
            for (let i = 0; i < prdtItem.item.length; i++) {
              newAdvrtsTpCodeJson[prdtItem.item[i].value] = 1;
              selectedCodes[prdtItem.item[i].value] = 1;
            }
          } else if (prdtItem.value === advrtsPrdtCode) {
            for (let i = 0; i < prdtItem.item.length; i++) {
              if (prdtItem.item[i].value === '00') continue;
              newAdvrtsTpCodeJson[prdtItem.item[i].value] = 1;
              selectedCodes[prdtItem.item[i].value] = 1;
            }
            break;
          }
        }
      } else {
        newAdvrtsTpCodeJson = {};
        selectedCodes = {};
      }
    } else {
      if (typeof newAdvrtsTpCodeJson['00'] !== 'undefined')
        delete newAdvrtsTpCodeJson['00'];
      if (checked) {
        newAdvrtsTpCodeJson[advrtsTpCode] = 1;
        selectedCodes[advrtsTpCode] = 1;
      } else {
        delete newAdvrtsTpCodeJson[advrtsTpCode];
        delete selectedCodes[advrtsTpCode];
      }
    }
    setSelectedTpCodes(selectedCodes);
  };
  return (
    <>
      {filterList.allProductCode.size !== 0 && (
        <Popover
          label={
            typeof params.advrtsTpCode === 'undefined' ||
            params.advrtsTpCode === '00'
              ? t('디스플레이')
              : typeof advrtsPrdtCode === 'undefined' || advrtsPrdtCode === null
              ? ''
              : productCodeList.get(advrtsPrdtCode).label
          }
          getOnClose={getOnClose}
          selectedLabel={returnSelectedLabel(filterList.allProductCode)}
          filtered={typeof params.advrtsTpCode !== 'undefined'}
          filterList={
            <FilterListIndex
              name={id}
              handleOnClickFilter={handleOnClick}
              advrtsPrdtCode={selectedPrdtCode}
              advrtsTpCode={selectedTpCodes}
              displayFilterList={displayFilterList}
              handleSaveClick={handleSaveClick}
            />
          }
          popoverHeight={540}
          createOnOpen
        />
      )}

      <SnackbarWrap
        open={alert.state}
        onClose={handleAlertClose}
        variant="warning"
        message={alert.message}
      />
    </>
  );
};

export default DisplayFilter;
